import { BuildingReviewModel } from 'common/data/building-review/model';
import { BuildingReviewFormInputInterface } from 'desktop/module/building-review/form/input.interface';

/**
 * Converts @props into a BuildingReviewModel
 */
export class BuildingReviewFormModelAdapter {
  /**
   * Constructor
   */
  constructor(protected input: BuildingReviewFormInputInterface) {}

  /**
   * Converts data into model
   */
  public getData(): BuildingReviewModel {
    const model = new BuildingReviewModel();

    model.ratings = {
      maintenance: this.input.rating_maintenance.value,
      staff_and_security: this.input.rating_staff_and_security.value,
      pool_and_gym: this.input.rating_pool_and_gym.value,
      children_friendly: this.input.rating_children_friendly.value,
      noise_in_and_around: this.input.rating_noise_in_and_around.value,
      traffic_near: this.input.rating_traffic_near.value,
      guest_parking: this.input.rating_guest_parking.value,
    };
    model.title = this.input.title.value;
    model.text = this.input.text.value;
    model.reviewer_name = this.input.reviewer_name.value.trim();
    model.reviewer_email = this.input.reviewer_email.value.trim();

    return model;
  }
}
